import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from "@skylab-shared/core";
import { fillPlaceholders } from "@skylab-shared/utils";

export interface OrderMatchOfferToProductParams {
	productId: string;
	offerId: string;
}

export class OrderMatchOfferToProductCommand extends Command<OrderMatchOfferToProductParams, void>{}

export class OrderMatchOfferToProductCommandBase implements CommandHandler<OrderMatchOfferToProductCommand, OrderMatchOfferToProductParams, void>{
	private static Url = TaggedUrl.join('Products/:productId/offer/:offerId', [Tags.SelloApi]);
	public constructor(private readonly http: HttpService) {}

	public async handleAsync(command: OrderMatchOfferToProductCommand): Promise<void> {
		const url = fillPlaceholders(OrderMatchOfferToProductCommandBase.Url, {
			productId: command.params?.productId,
			offerId: command.params?.offerId,
		});
		await this.http.post(url);
	}
}
